import React from "react";
import { Alert, Space, Typography } from "antd";
import dayjs from "dayjs";
import {
  MonitorStatus,
  OverallState,
} from "../../../interfaces/paymentHealth.interface";
import { overallStateMeta } from "../paymentHealthDisplay";

interface StatusBannerProps {
  overallState: OverallState;
  monitor: MonitorStatus;
  generatedAt: string;
}

const StatusBanner: React.FC<StatusBannerProps> = ({
  overallState,
  monitor,
  generatedAt,
}) => {
  const meta = overallStateMeta(overallState);
  const isUnknown = overallState === "unknown";

  const description = (
    <Space direction="vertical" size={2}>
      <Typography.Text type="secondary">
        Updated {dayjs(generatedAt).format("MMM D, HH:mm:ss")}
      </Typography.Text>
      {isUnknown && (
        <Typography.Text type="secondary">
          {monitor.stale
            ? `Alerter last ran ${
                monitor.lastRunAt
                  ? dayjs(monitor.lastRunAt).format("MMM D, HH:mm")
                  : "never"
              } - the monitor is blind, so status cannot be confirmed.`
            : "Mixpanel fetch is failing - the monitor cannot confirm status."}
          {monitor.lastError ? ` (${monitor.lastError})` : ""}
        </Typography.Text>
      )}
    </Space>
  );

  return (
    <Alert
      type={meta.bannerType}
      showIcon
      message={
        <Typography.Text strong style={{ fontSize: 16 }}>
          {meta.label}
        </Typography.Text>
      }
      description={description}
      style={{ marginBottom: 24, borderLeft: `4px solid ${meta.color}` }}
    />
  );
};

export default StatusBanner;
